module.exports = __webpack_public_path__ + "resources/img/main09.2b3457ac57cd9e68978026c557a4be38.png";